"use client";

import { c as _c } from "react/compiler-runtime";
import { type ReactNode } from "react";
import { SmoothScroll } from "./smooth-scroll";
import { CustomCursor } from "./custom-cursor";

// Client wrapper for the whole marketing page: smooth scroll + custom cursor.
// No intro gate, so the hero plays its entrance the moment it mounts.
export const MarketingShell = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <CustomCursor />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <SmoothScroll>{t1}{children}</SmoothScroll>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};